<template>
<div class="groupQR-wrap">
  <div class="logo"></div>
  <div class='langwrap'>
    <div class='btnNavi langNavi' v-if="this.isGlobalButtonEnabled()">
      <span
        @click="toggleLangBox()"
        class="ico lang"
        :class="{ ko: isKo, en: isEn, cn: isCn}"></span>
      <div class="langBox" style="display: none">
        <span class="ico lang ko" @click="setKorean()"></span>
        <span class="ico lang en" @click="setEnglish()"></span>
        <span class="ico lang ch" @click="setChinese()"></span>
      </div>
    </div>
  </div>
  <div class="body-set">
    <div class="content-flex">
      <ul class="sub-header">
        <li class="address" v-if="groupQrData.isFixedAddress == 'Y'" v-show="groupQrData.orderGroupName">
          {{groupQrData.orderGroupName}} {{ detailAddress2 ? detailAddress2 : '' }}
        </li>
        <li class="address" v-else v-show="addressByLotNum">
          {{addressByLotNum}}
        </li>
        <!-- <li class="address" v-if="groupQrData.roomServiceUseYn == 'Y' || groupQrData.taxiCallUseYn == 'Y'" v-show="groupQrData.orderGroupName">
          {{groupQrData.orderGroupName}} {{ detailAddress ? detailAddress : '' }}
        </li>
        <li class="address" v-else v-show="addressByLotNum">
          {{addressByLotNum}}
        </li> -->
        <li class="section-title">
          {{$t('QR.service')}} <span class="fc-FF5522">{{$t('QR.pleaseChoose')}}</span>
        </li>
      </ul>
      <ul class="hotel-service-wrap">
        <li class="room-service" @click="roomServiceUrl()" v-if="groupQrData.roomServiceUseYn == 'Y'">
          <img src="../assets/img/ic_hotel_roomservice.png" alt="">
          <div class="service-content">
            <div class="service-top">
              <p>{{$t('QR.roomService')}}</p>
              <span class="arrow"></span>
            </div>
            <div class="service-bot">
              <span>#{{$t('QR.conciergeService')}} #{{$t('QR.pickUp')}}</span>
            </div>
          </div>
        </li>
        <li class="hotel-delivery" @click="hotelDelivery()">
          <img src="../assets/img/ic_hotel_delivery.png" alt="">
          <div class="service-content">
            <div class="service-top">
              <p>{{$t('QR.foodDelivery')}}</p>
              <span class="arrow"></span>
            </div>
            <div class="service-bot">
              <span>{{$t('QR.freeDelivery')}} #{{$t('QR.famousRestaurant')}}</span>
            </div>
          </div>
        </li>
        <li class="taxi-call" @click="taxiCall()" style="display:none" v-if="groupQrData.taxiCallUseYn == 'Y'">
          <img src="../assets/img/ic_hotel_taxi.png" alt="">
          <div class="service-content">
            <div class="service-top">
              <p>{{$t('QR.taxi')}}</p>
              <span class="arrow"></span>
            </div>
            <div class="service-bot">
              <span>#{{$t('QR.callTaxi')}} #{{$t('QR.airport')}}</span>
            </div>
          </div>
        </li>
        <li class="taxi-call" v-if="groupQrData.taxiCallUseYn == 'Y'">
          <img src="../assets/img/ic_hotel_taxi.png" alt="" class="grayFilter">
          <div class="service-content">
            <div class="service-stop">
              <p>{{$t('QR.taxi')}}</p>
              <span>{{$t('QR.comingSoon')}}</span>
            </div>
            <div class="service-bot" style="color: #818181">
              <span>#{{$t('QR.callTaxi')}} #{{$t('QR.airport')}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="bottom-banner" v-if="$i18n.locale == 'cn'">
      <img src="../assets/img/banner-main-web-01-chi.png" style="width: 100%;">
    </div>
    <div class="bottom-banner" v-else-if="$i18n.locale == 'en'">
      <img src="../assets/img/banner-main-web-01-en.png" style="width: 100%;">
    </div>
    <div class="bottom-banner" v-else>
      <img src="../assets/img/banner-main-web-01-kor.png" style="width: 100%;">
    </div>
  </div>
  <AppCompanyInfo/>
</div>
</template>
<script>
import $ from 'jquery'
import AppCompanyInfo from '@/components/App/AppCompanyInfo.vue'
import service from '@/backend/modnpay_app_api'
export default {
  name: 'HotelService',
  components: { AppCompanyInfo },
  data () {
    return {
      list: [], // 그룹QR 카테고리 응답리스트
      groupQrData: JSON.parse(sessionStorage.getItem('GroupQrData')),
      detailAddress2: '',
      addressByLotNum: ''
    }
  },
  computed: {
    isKo () {
      return this.$i18n.locale === 'ko'
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isCn () {
      return this.$i18n.locale === 'cn'
    }
  },
  mounted () {
    if (this.groupQrData.isFixedAddress == 'Y') {
      this.hotelServiceFlag = true
      this.detailAddress2 = JSON.parse(sessionStorage.getItem('selectAddress')).detailAddress2
    }
    if (this.$route.query.addressByLotNum) {
      this.addressByLotNum = this.$route.query.addressByLotNum
    } else {
      this.addressByLotNum = JSON.parse(sessionStorage.getItem('selectAddress')).jibunAddr
    }
    this.callCategoryList()
  },
  updated () {
    sessionStorage.getItem('langType')
      ? this.$i18n.locale = sessionStorage.getItem('langType')
      : this.$i18n.locale = this.$store.getters.langType
  },
  methods: {
    toggleLangBox () {
      $('.langNavi .langBox').fadeToggle(200)
    },
    setKorean () {
      this.$i18n.locale = 'ko'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      // this.$emit('reloadMainPage')
      this.toggleLangBox()
    },
    setEnglish () {
      this.$i18n.locale = 'en'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      // this.$emit('reloadMainPage')
      this.toggleLangBox()
    },
    setChinese () {
      this.$i18n.locale = 'cn'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = 'MODNPAY智慧点餐'
      // this.$emit('reloadMainPage')
      this.toggleLangBox()
    },
    hotelDelivery () {
      this.$router.push({
        name: 'AppMain',
        query: {
          addressByLotNum: this.addressByLotNum // 지번주소
        }
      })
    },
    taxiCall () {
    },
    async roomServiceUrl () { // 매장 QR URL 요청
      const req = {
        urlCode: this.groupQrData.storeCode,
        introUrlType: 0
      }
      const res = await service.storeIntroUrl(req)
      if (res.data.resultCode == 0) {
        let baseUrl = res.data.introUrl
        const currentURL = window.location.href
        if (currentURL.indexOf('localhost') !== -1) {
          baseUrl = 'http://localhost:8003/menu/modn/mobile/ui/main?token=eyJ0b2tlbiI6ImQzMmU2NTlmLWQ3MGItNDM2Yy05YmNhLTNlNGE0ZmY5YzExYiIsIm9yZGVyU2VxIjoiMjMxMjAxMDA1MDYwNjIiLCJzdG9yZUNvZGUiOjI2MjYsInN0b3JlTmFtZSI6IuuqqOuToCDrtoTsi50iLCJvcmRlclRva2VuIjoiNDE0Mzc1MjEzYjEwNDUzNTA4MzU0MTljOWMxZmNmMTYxOTI1MmNiYzU4N2ViZDMzY2EiLCJ0YWJsZU5vIjotMSwiY2FyZENvZGUiOiIwMDAiLCJjcmVkaXQiOnRydWUsInFyVHlwZSI6MSwiYWxpdmUiOmZhbHNlfQ%3D%3D'
        }
        sessionStorage.removeItem('tradition')
        sessionStorage.removeItem('categoryCode')
        sessionStorage.removeItem('addressByLotNum')
        sessionStorage.removeItem('time')
        window.location.href = baseUrl// 가맹점 QR URL 리다이렉트하기
      } else {
        this.toast(this, res.data.resultMsg)
      }
    },
    async callCategoryList () { // 카테고리 및 주소 조회
      const req = {
        orderGroupSeq: this.groupQrData.orderGroupSeq,
        orderGroupFixedCode: this.groupQrData.orderGroupFixedCode
      }
      const { data } = await service.categoryList(req)

      if (data.resultCode == '0000000') { // 성공
        this.list = data.list
      }
    },
    setImg (code) {
      switch (code) {
        case '010100': return require('../assets/img/ic_food_korea.png')
        case '020100': return require('../assets/img/ic_food_chicken.png')
        case '030100': return require('../assets/img/ic_food_ricecake.png')
        case '040100': return require('../assets/img/ic_food_china.png')
        case '050100': return require('../assets/img/ic_food_japan.png')
        case '060100': return require('../assets/img/ic_food_bowl.png')
        case '070100': return require('../assets/img/ic_food_pizza.png')
        case '080100': return require('../assets/img/ic_food_buger.png')
        case '090100': return require('../assets/img/ic_food_western.png')
        case '100100': return require('../assets/img/ic_food_pig.png')
        case '110100': return require('../assets/img/ic_food_cake.png')
        case '120100': return require('../assets/img/ic_food_salad.png')
        case '130100': return require('../assets/img/ic_food_night.png') // 야식
        case '140100': return require('../assets/img/ic_food_asian.png') // 아시안
        case '150100': return require('../assets/img/ic_food_meat.png') // 고기구이
        case '160100': return require('../assets/img/ic_food_franchise.png') // 프랜차이즈
      }
    }
  }
}
</script>
<style scoped>
.button-group__first-line-image{flex-wrap: wrap;}
#footer{ background-color: #fff; margin-top: 56px; padding-bottom: 0;}
</style>
